import type { FaireProductEntity } from "../../entity_types/product";

export const p_c9f9q5putg: FaireProductEntity = {
  token: "p_c9f9q5putg",
  type: "product",
  name: "SKATE DECK SPOT SERIES SOUTH BANK\nRef. S0009-04 8”",
  brandToken: "b_9grp69f3nm",
  brandName: "Hydroponic",
  imageUrl:
    "https://cdn.faire.com/fastly/cb25f5199973efc9b868b9f3848e9dc891c73921f224201b503eda5aac1ff52e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/144b766dbd2f919fd14833da7133347660f85bb6aad9f5c6b83face3f8446be7.jpeg",
  ],
  priceDollars: 39.9,
  description:
    'HYDROPONIC Skate boards are high quality decks made with 7 folds of Canadian Hard Rock Maple wood and glued with ultra-strong Epoxy resin to get a reactive pop that will last for the whole life of the board. HYDROPONIC Skate decks come in a wide variety of sizes, depending on your height, weight and Skate Style. \n\nDeck: 7-ply Hard Rock Canadian Maple + Epoxy Resin\n\nLength: 31.5"\n\nWidth: 8"\n\nWheel Base: 14\'\n\nConcave: High',
  tags: [],
  msrpDollars: 79.8,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:27.759Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
